<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2 16V13.2"
      stroke="white"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.8 4.80001H2"
      stroke="white"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 4.8H13.2V9"
      stroke="white"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0008 13.2H4.80078V2"
      stroke="white"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CropIcon"
};
</script>
